import type { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip, TooltipPlacement } from '../../ui-components';
import { BasicError } from '../basic-error/BasicError';

const SafoniaWarningCart: FC = () => {
    const intl = useIntl();

    return (
        <BasicError
            options={{
                alertDataTestId: 'cart-safonia-warning-container',
                errorMessageDataTestId: 'cart-safonia-warning-message',
            }}
        >
            <FormattedMessage
                id="safonia.checkout.message.content"
                defaultMessage="Some items in your bag cannot be purchased in your billing location."
            />{' '}
            <Tooltip
                label={intl.formatMessage({
                    defaultMessage:
                        'Shipping protection services cannot be purchased by New York residents due to licensing requirements.',
                    id: 'safonia.checkout.message.button.tooltip',
                })}
                placement={TooltipPlacement.topLeft}
            >
                <Box
                    as="span"
                    id="safonia-checkout-details-button"
                    color="slt-red-error"
                    textDecoration="underline"
                    textUnderlineOffset={2}
                >
                    <FormattedMessage
                        id="safonia.checkout.message.button"
                        defaultMessage="Details"
                    />
                </Box>
            </Tooltip>
        </BasicError>
    );
};

export { SafoniaWarningCart };
